<mwe-basic-card>
  <h6 translate="summary.additionalDetails"></h6>
  <div class="row w-100">
    <div class="col-12">
      <ul class="list-separated spacing-4" data-test="products-summary-additionalDetails">
        @if (showMeterReading) {
          <li data-test="products-summary-additionalDetails-showMeterReading">
            <p class="text--big mb-0">
              <strong><span translate="summary.meterReading.title"></span></strong><br />
              <span translate="summary.meterReading.description"></span>
            </p>
          </li>
        }
        @if (voucherInfoSignal()) {
          <li data-test="products-summary-additionalDetails-voucher">
            <p class="text--big mb-0">
              <strong
                ><span
                  translate="summary.voucherInfo.title"
                  [translateParams]="{ voucherCode: voucherInfoSignal().aktionscode }"
                ></span></strong
              ><br />
              @if (voucherStrom()?.length > 0) {
                <span [innerHTML]="voucherStrom() + '<br/>'"></span>
              }
              @if (voucherGas()?.length > 0) {
                <span [innerHTML]="voucherGas() + '<br/>'"></span>
              }
            </p>
          </li>
        }
        @if (mgmCode) {
          <li data-test="products-summary-additionalDetails-mgmCode">
            <p class="text--big mb-0">
              <strong><span translate="newClient.mgm.summaryTitle"></span></strong><br />
              <span> {{ mgmCode }}</span>
            </p>
          </li>
        }
      </ul>
    </div>
  </div>
</mwe-basic-card>
